import React from 'react';
import LinkButton from '../../LinkButton/LinkButton';
import { toName, createLink } from '../../../utils';
import { useGlobalValue } from '../../../state/GlobalProvider';
import styles from './FindingRow.module.sass';

const FindingRow = ({
  data = {}
} = {}) => {
  const {
    message,
    referenceType,
    referenceId,
    severity,
    verified
  } = data;
  const {
    proxy,
    i18n,
    params
  } = useGlobalValue();
  const type = referenceType.split('::').pop();
  const referenceName = toName(type);
  const link = createLink(undefined, proxy, {
    __typename: type,
    id: referenceId
  }, params);
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles['row']} ${styles[`severity-${severity}`]}`
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", {
    className: styles['description']
  }, message)), /*#__PURE__*/React.createElement("div", {
    className: styles['align-center']
  }, link ? /*#__PURE__*/React.createElement(LinkButton, {
    label: referenceName,
    to: link
  }) : /*#__PURE__*/React.createElement("h5", null, referenceName)), /*#__PURE__*/React.createElement("div", {
    className: `${styles['align-center']} ${styles[verified ? 'valid' : 'invalid']}`
  }, /*#__PURE__*/React.createElement("small", null, verified ? i18n('Verified') : i18n('Not Verified'))));
};

FindingRow.header = [{
  label: ["Finding"],
  align: 'left'
}, {
  label: ["Location"],
  align: 'center'
}, {
  label: ["Status"],
  align: 'center'
}];
FindingRow.mobileHeader = [];
export default FindingRow;